import { render, staticRenderFns } from "./Forms.vue?vue&type=template&id=51f37e1f&scoped=true&"
import script from "./Forms.vue?vue&type=script&lang=js&"
export * from "./Forms.vue?vue&type=script&lang=js&"
import style0 from "./Forms.vue?vue&type=style&index=0&id=51f37e1f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f37e1f",
  null
  
)

export default component.exports